import React, { useRef } from 'react'
import Room from './Room'
import './Room.css'

export default function Rooms({roomsData, reservedRooms, lockedRooms, mapConfig, lockIconUrl, mapRef, zoomLevel, markerOpacity}) {

  const overlays = useRef({})

  return (
    <div>
      {roomsData?.map((room, index) => {
        const isLocked = lockedRooms?.includes(room.room_id);
        const hasEvent = reservedRooms?.includes(room.room_id);
        
        return (
          <Room
            key={room.room_id}
            room={room}
            index={index}
            isLocked={isLocked}
            hasEvent={hasEvent}
            mapConfig={mapConfig}
            lockIconUrl={lockIconUrl}
            mapRef={mapRef}
            overlays={overlays}
            zoomLevel={zoomLevel}
            markerOpacity={markerOpacity}
          />
        );
      })}
    </div>
  )
}